import React from "react";
import { Button, Icon } from "aible";
import { Popover, OverlayTrigger } from "react-bootstrap";

import { getColor, getIcon } from "aible/Tile/Tile";
import TileIcon from "aible/Tile/TileIcon";

import styles from "./style.module.css";

export const TILE_TITLE_NAME = "AIBLE_TileTile";

/*
  IMPORTANT:

  If this is a child of the `Tile` component and the parent has an onClick,
  the parent will inject the onClick into this component
*/
export default class TileTitle extends React.PureComponent {
  static displayName = TILE_TITLE_NAME;

  getColor() {
    const { color } = this.props;

    return getColor(color);
  }

  getIcon() {
    const { icon } = this.props;
    return getIcon(icon);
  }

  render() {
    const {
      title,
      icon,
      iconDiv,
      overlay,
      noOverlay,
      color,
      style,
      className,
      children,
      onClick,
      innerStyle,
      ...retProps
    } = this.props;

    return (
      <div
        className={styles.tileTitleWrapper + " " + (onClick ? styles.onClick : "") + " " + (className ? className : "")}
        style={{
          background: this.getColor(),
          color: color && color !== "default" ? undefined : "#4B495B",
          minHeight: "40px",
          ...style
        }}
        onClick={onClick}
        {...retProps}
      >
        {iconDiv !== undefined ? <div>{iconDiv}</div> : <TileIcon icon={this.getIcon()} />}
        <OverlayTrigger
          placement="top"
          trigger={noOverlay || (!noOverlay && !title) ? [] : ["hover"]}
          rootClose
          overlay={
            <Popover id="popover-positioned-top">
              {overlay ? overlay : <div className={styles.popoverList}>{title}</div>}
            </Popover>
          }
        >
          {typeof children === "string" ? (
            <div className={styles.tileTitle} style={innerStyle ? innerStyle : {}}>
              {children}
            </div>
          ) : (
            <React.Fragment>{children}</React.Fragment>
          )}
        </OverlayTrigger>
      </div>
    );
  }
}
